/**
 *
 *
 *
 *
 *
 *
 *
 */
import { onexAsync, onexSync, type OnexAsync } from "../globals/onex.js";

export * from "../lib/onex/head/mappers.js";
export * from "../lib/onex/head/reactive.js";
export * from "../lib/onex/async/mappers.js";
/*                                                   */

export {
  /*                                                                   */
  onexAsync,
  /*                                                                   */
  onexSync as onex,
};

/**
 *
 *
 *
 *
 */
export const assignments: OnexAsync["assignments"] = onexAsync.assignments;

/**
 *
 *
 *
 *
 */
export const getAssignments: OnexAsync["getAssignments"] = onexAsync.getAssignments;
